import { APIResponseType } from 'app/apiService/types';
import apiService from '..';

interface DealerGroupPayload {
  name: string;
  dealers: string[];
  type: string;
  settings?: any;
}

interface DealerGroupEditPayload {
  name?: string;
  dealers?: string[];
  settings?: any;
}

class DealerGroup {
  static ENDPOINT = 'api/v2/dealer-groups';

  static async getDealerGroup(dealerGroupId: string): Promise<APIResponseType> {
    if (!dealerGroupId) throw new Error("DealerGroup ID is required to fetch details");
    try {
      const response = await apiService.get<APIResponseType>(`${this.ENDPOINT}/${dealerGroupId}`);
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async getAllDealerGroups(params?: any): Promise<APIResponseType> {
    try {
      const response = await apiService.get<APIResponseType>(`${this.ENDPOINT}?audit_meta.created_user_type=USER`, params);
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async addDealerGroup(payload: DealerGroupPayload): Promise<APIResponseType> {
    try {
      const response = await apiService.post<APIResponseType>(`${this.ENDPOINT}`, payload);
      await apiService.invalidateCacheByPrefix(this.ENDPOINT, 'GET');
      await apiService.invalidateCacheByPrefix(`${this.ENDPOINT}/datagrid`);
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async deleteDealerGroup(dealerGroupId: string): Promise<APIResponseType> {
    if (!dealerGroupId) throw new Error("DealerGroup ID is required for deletion");
    try {
      const response = await apiService.delete<APIResponseType>(`${this.ENDPOINT}/${dealerGroupId}`);
      await apiService.invalidateCacheByPrefix(this.ENDPOINT, 'GET');
      await apiService.invalidateCacheByPrefix(`${this.ENDPOINT}/datagrid`);
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async attachDealersToDealerGroup(dealerGroupId: string, data: any): Promise<APIResponseType> {
    if (!dealerGroupId) throw new Error("DealerGroup ID is required for deletion");
    try {
      const response = await apiService.put<APIResponseType>(`${this.ENDPOINT}/attach-dealers/${dealerGroupId}`, data);
      await apiService.invalidateCacheByPrefix(this.ENDPOINT, 'GET');
      await apiService.invalidateCacheByPrefix(`${this.ENDPOINT}/datagrid`);
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async editDealerGroup(dealerGroupId: string, payload: DealerGroupEditPayload): Promise<APIResponseType> {
    if (!dealerGroupId) throw new Error("DealerGroup ID is required for editing");
    if (!Object.keys(payload).length) throw new Error("Edit payload cannot be empty");

    try {
      const response = await apiService.put<APIResponseType>(`${this.ENDPOINT}/${dealerGroupId}`, payload);
      await apiService.invalidateCacheByPrefix(this.ENDPOINT, 'GET');
      await apiService.invalidateCacheByPrefix(`${this.ENDPOINT}/datagrid`);
      return response;
    } catch (error) {
      throw error;
    }
  }
}

export default DealerGroup;
